export class EnrolmentGroup {
	constructor(public displayText: string) {}
}
